// extracted by mini-css-extract-plugin
export default {"hover-currency-menu-footer":"hover-currency-menu-footer--8eT4c","hoverCurrencyMenuFooter":"hover-currency-menu-footer--8eT4c"};